var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ide-page"},[_c('header',[_c('h1',[_vm._v("全智模版IDE")]),_c('ul',[_c('li',[_c('el-button',{attrs:{"size":"mini","disabled":_vm.isWorking.save},on:{"click":_vm.save}},[_vm._v("保存")])],1)])]),_c('IDE',{ref:"ide",attrs:{"template-id":_vm.templateId,"files":_vm.files,"props":_vm.props}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }